import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Drawer, Field, Input, Select } from '@itds/elements/index.js';
import { HEALTH_CATEGORIES } from '@itds/Constants';

import Api from '@carrier/utils/Api';

const Edit = ({ category, onClose, onSave, show }) => {
  const [data, setData] = useState({
    id: null,
    carrier_id: null,
    data_version_id: null,
    carrier_health_category: '',
    ien_health_category: '',
    tobacco_category_type: ''
  });
  const [errors, setErrors] = useState([]);
  const [save_error, setSaveError] = useState(false);

  useEffect(() => {
    const new_category = category || {};

    setData({
      id: new_category.id,
      carrier_id: new_category.carrier_id,
      data_version_id: new_category.data_version_id,
      carrier_health_category: new_category.carrier_health_category || '',
      ien_health_category: new_category.ien_health_category || HEALTH_CATEGORIES[0],
      tobacco_category_type: new_category.tobacco_category_type || 'Non Tobacco'
    });
  }, [category]);

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleSave = () => {
    const errors = [];

    if (!data.carrier_health_category) {
      errors.push('carrier_health_category');
    }

    setErrors(errors);

    if (!errors.length) {
      const { id, ...payload } = data;

      Api.saveHealthCategory(id, payload)
        .then(() => {
          onSave();
          setSaveError(false);
        })
        .catch(() => {
          setSaveError(true);
          setTimeout(() => {
            setSaveError(false);
          }, 2000);
        });
    }
  };

  return (
    <Drawer
      alignRight={true}
      footer={
        <Button onClick={handleSave}>{data.id ? 'Save Changes' : 'Create Health Category'}</Button>
      }
      onClose={onClose}
      show={show}
      title={data.id ? 'Editing Health Category' : 'New Health Category'}
    >
      {save_error ? (
        <Alert type='error'>An error occurred while trying to save the modal factor.</Alert>
      ) : null}

      <Field label='Carrier Health Category Name'>
        <Input
          invalid={errors.includes('carrier_health_category')}
          onChange={handleInputChange.bind(null, 'carrier_health_category')}
          required={true}
          value={data.carrier_health_category}
        />
      </Field>

      <Field label='IXN Health Category'>
        <Select
          onChange={handleInputChange.bind(null, 'ien_health_category')}
          options={HEALTH_CATEGORIES.map(c => ({ value: c }))}
          required={true}
          value={data.ien_health_category}
        />
      </Field>

      <Field label='Tobacco Category Type'>
        <Select
          onChange={handleInputChange.bind(null, 'tobacco_category_type')}
          options={[
            { value: 'Non Tobacco', label: 'Non Tobacco' },
            { value: 'Tobacco', label: 'Tobacco' }
          ]}
          required={true}
          value={data.tobacco_category_type}
        />
      </Field>
    </Drawer>
  );
};

Edit.propTypes = {
  category: PropTypes.object,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  show: PropTypes.bool
};

export default Edit;
